import { createFileRoute } from "@tanstack/react-router";
import Messages from "@/components/Support";
import Responsiveness from "@/components/Support/Responsiveness";
import { useSearchParams } from "@/lib/navigation";

const MessagesPage = () => {
  const searchParams = useSearchParams();
  const channelId = searchParams.get("channel_id") as string | undefined;

  return (
    <div className="space-y-4">
      <Responsiveness />
      <Messages initialChannelId={channelId} />
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/chat/")({
  component: MessagesPage,
  staticData: { page: "support" },
});
